// Add your JS customizations here
jQuery(document).ready(function($) {

	$('body').addClass('active');
	new WOW().init();

	$(window).on('scroll', function() {

		if ($(this).scrollTop() > 100) {
    		$('#floater').addClass('scrolled');
    		$('.navbar').addClass('scrolled');
    	} else {
    		$('#floater').removeClass('scrolled');
    		$('.navbar').removeClass('scrolled');
    	}

	});

	$(window).load(function() {

		if ($(this).scrollTop() > 100) {
    		$('#floater').addClass('scrolled');
    		$('.navbar').addClass('scrolled');
    	} else {
    		$('#floater').removeClass('scrolled');
    		$('.navbar').removeClass('scrolled');
    	}

	});

	if ($('.page-template-treatment_category').length > 0) {
		$('.navbar').addClass('bg-white');
	};

	if ($('.treatment_search').length > 0) {
		$('.navbar').addClass('bg-white');
	};

	if ($('.page-template-policy').length > 0) {
		$('.navbar').addClass('bg-white');
	};

	if ($('.single-team_member').length > 0) {

		$('.member_more').click(function(event) {
			event.preventDefault();
			var target = $(this).data('parent');
			$(target).toggleClass('remove_gradient');
			$(this).text($(this).text() == 'Load more' ? 'Show less' : 'Load more');
		});

	}

	if ($('.page-template-information').length > 0) {
		$('.navbar').addClass('bg-white');

		$('.expand_more').click(function(event) {
			event.preventDefault();
			var target = $(this).attr('href');
			$(target).toggleClass('expanded');
			$(this).text($(this).text() == 'Load more' ? 'Show less' : 'Load more');
		});
	};

	if ($('.page-template-gallery').length > 0) {
		$('.navbar').addClass('bg-white');

		$('#galleries_accordion .card-header a').click(function() {
			$(window).scrollTop(0);
		});
	};

	if ($('.page-template-videos').length > 0) {
		$('.navbar').addClass('bg-white');
	};

	if ($('.page-template-prices').length > 0) {
		$('.navbar').addClass('bg-white');
		$('#galleries_accordion .card-header a').click(function() {
			$(window).scrollTop(0);
		});
	};

	if ($('.page-template-feedback').length > 0) {
		$('.navbar').addClass('bg-white');
		$('#patient_feedback').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			fade: true,
			infinite: true,
			arrows: true,
			prevArrow: $('.test_prev'),
			nextArrow: $('.test_next'),
		});

		$('#handwritten_feedback a').click(function() {
			var src = $(this).data('img');

			$('#feedback_image img').attr('src',src);
		});
	};

	if ($('.page-template-professionals').length > 0) {
		$('.navbar').addClass('bg-white');
		if ($(window).width() > 992) {
			var form_height = $('#professionals_form_container').outerHeight(true);
		    $('#professionals_form_bg .card').css('height',form_height);

		    $( window ).resize(function() {
				var form_height_resize = $('#professionals_form_container').outerHeight(true);
			    $('#professionals_form_bg .card').css('height',form_height_resize);
			});
		};		
	};

	if ($('.page-template-careers').length > 0) {
		if ($(window).width() > 992) {
			var form_height = $('#professionals_form_container').outerHeight(true);
		    $('#professionals_form_bg .card').css('height',form_height);

		    $( window ).resize(function() {
				var form_height_resize = $('#professionals_form_container').outerHeight(true);
			    $('#professionals_form_bg .card').css('height',form_height_resize);
			});
		};		
	};

	if ($('.page-template-team').length > 0) {
		$('.navbar').addClass('bg-white');

		$('.team_more').click(function(event) {
			event.preventDefault();
			var target = $(this).data('parent');
			$(target).find('.gallery_item.hide_xs').toggleClass('show');
			$(this).text($(this).text() == 'Load more' ? 'Show less' : 'Load more');
		});

		$('#galleries_accordion .card-header a').click(function() {
			$(window).scrollTop(0);
		});
	};

	$('.hamburger').click(function(event) {
		event.preventDefault();
		$('#search').removeClass('active');
		$('#main-nav').removeClass('search_open');
		$('.dropdown-toggle').removeClass('show').attr('aria-expanded',false);
		$('.dropdown-menu').removeClass('show');
		if($(this).hasClass('is-active')) {
			$(this).removeClass('is-active');
			$('#main-nav').removeClass('menu_open');
			$('body').removeClass('modal-open');
			$('#mobile_menu').removeClass('active');
		} else {
			$(this).addClass('is-active');
			$('#main-nav').addClass('menu_open');
			$('#mobile_menu').scrollTop(0);
			$('body').addClass('modal-open');
			$('#mobile_menu').addClass('active');
		}
	});

	$('.navbar_search').click(function(event) {
		event.preventDefault();
		$('#search').toggleClass('active');
		$('#main-nav').toggleClass('search_open');
		$('body').toggleClass('modal-open');
		$(this).toggleClass('search_open');
	});

	$('.search_mobile').click(function(event) {
		event.preventDefault();
		$('#mobile_menu').removeClass('active');
		$('#search').addClass('active');
		$('.hamburger').removeClass('is-active');
		$('#main-nav').addClass('search_open').removeClass('menu_open');
	});

	$('.close_search').click(function(event) {
		event.preventDefault();
		$('#search').removeClass('active');
		$('#main-nav').removeClass('search_open');
		$('body').removeClass('modal-open');
	});

	if ($('.single-before_after').length > 0) {
		$('.navbar').addClass('bg-offwhite');
		$('#before_afters_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			fade: false,
			speed: 2000,
			centerMode: true,
			centerPadding: '25%',
			infinite: true,
			arrows: true,
			prevArrow: $('.ba_prev'),
			nextArrow: $('.ba_next'),
			asNavFor: $('#before_afters_thumbs'),
			responsive: [
				{
					breakpoint: 769,
					settings: {
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						centerMode: false,
						centerPadding: 0,
					},

				}
			]
		});
		$('#before_afters_thumbs').slick({
			slidesToShow: 6,
			slidesToScroll: 1,
			autoplay: false,
			fade: false,
			speed: 2000,
			infinite: false,
			arrows: true,
			centerMode: true,
			prevArrow: $('.ba_thumb_prev'),
			nextArrow: $('.ba_thumb_next'),
			focusOnSelect: true,
			asNavFor: $('#before_afters_carousel'),
			responsive: [
				{
					breakpoint: 769,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						infinite: true,
						arrows: false,
						centerMode: true,
						centerPadding: 0,
					},
				}
			]
		});
	};

	if ($('.single-treatment').length > 0) {
		$('.navbar').addClass('bg-white');
		var costs = $('#costs .card').outerHeight(true);
		var costsBG = costs / 2;
		$('#costs_bg').css('height',costsBG);

		$( window ).resize(function() {
			var costs_resize = $('#costs .card').outerHeight(true);
			var costsBG_resize = costs_resize / 2;
			$('#costs_bg').css('height',costsBG_resize);
		});

		$('#glance_carousel').slick({
			slidesToShow: 6,
			slidesToScroll: 1,
			autoplay: false,
			infinite: false,
			responsive: [
				{
					breakpoint: 769,
					settings: {
						arrows: true,
						prevArrow: $('.glance_prev'),
						nextArrow: $('.glance_next'),
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
					},

				}
			]
		});

		$('#before_afters_carousel').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		    $.fn.matchHeight._groups;
		});

		$('#before_afters_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			fade: true,
			infinite: true,
			arrows: true,
			prevArrow: $('.ba_prev'),
			nextArrow: $('.ba_next'),
		});


		$('#videos_carousel').on('beforeChange',function(event, slick){
			var currentSlide, slideType, player, command;

			currentSlide = $(slick.$slider).find(".slick-current .ratio");

			slideType = currentSlide.attr("class").split(" ")[1];

			player = currentSlide.find("iframe").get(0);

			if (slideType == "vimeo") {
		        command = {
		          	"method": "pause",
		          	"value": "true"
		        };
	      	} else if (slideType == "youtube") {
		        command = {
		          	"event": "command",
		          	"func": "pauseVideo"
		        };
	      	} else {
	      		var src = $(".slick-current .ratio iframe").attr("src");
	      		$(".slick-current .ratio iframe").attr("src", src);
	      	}

	      	if (player != undefined) {
		        //post our command to the iframe.
		        player.contentWindow.postMessage(JSON.stringify(command), "*");
	      	}
		    
		});

		$('#videos_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			infinite: true,
			arrows: true,
			fade: true,
			adaptiveHeight: true,
			prevArrow: $('.video_prev'),
			nextArrow: $('.video_next'),
		});

		$('.team_more').click(function(event) {
			$(this).text($(this).text() == 'Load more' ? 'Show less' : 'Load more');
		});
	}

	$('#header_carousel').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    var slidesToShow = slick.slickGetOption('slidesToShow');
	    var curPage = parseInt((i-1)/slidesToShow) + 1;
	    var lastPage =  parseInt((slick.slideCount-1)/slidesToShow) + 1;
	    $('.hc_current').text(curPage);
	    $.fn.matchHeight._groups;
	});

	$('#header_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		fade: true,
		autoplaySpeed: 5000,
		speed: 1000,
		infinite: true,
		arrows: true,
		prevArrow: $('.hc_prev'),
		nextArrow: $('.hc_next'),
	});


	$('#hospital_features_carousel').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    var slidesToShow = slick.slickGetOption('slidesToShow');
	    var curPage = parseInt((i-1)/slidesToShow) + 1;
	    var lastPage =  parseInt((slick.slideCount-1)/slidesToShow) + 1;
	    $('.hf_current').text(curPage);
	    $.fn.matchHeight._groups;
	});
	

	$('#hospital_features_carousel').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		autoplay: false,
		infinite: true,
		arrows: false,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					arrows: true,
					prevArrow: $('.hf_prev'),
					nextArrow: $('.hf_next'),
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
					autoplaySpeed: 5000,
				},

			}
		]
	});

	$('#our_treatments_carousel').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    var slidesToShow = slick.slickGetOption('slidesToShow');
	    var curPage = parseInt((i-1)/slidesToShow) + 1;
	    var lastPage =  parseInt((slick.slideCount-1)/slidesToShow) + 1;
	    $('.t_current').text(curPage);
	    $.fn.matchHeight._groups;
	});



	$('.view_all_treatments').on('click', function(event) {
		if ($(window).width() > 992) {
			event.stopPropagation();
			$('#menu-item-172 .dropdown-toggle').attr('aria-expanded',true).toggleClass('show');
			$('#menu-item-172 .dropdown-menu').toggleClass('show');
		} else {
			event.stopPropagation();
			$('#mobile_menu').addClass('active');
			$('#mobile_menu').scrollTop(0);
			$('#main-nav').addClass('menu_open');
			$('.hamburger').addClass('is-active');
			$('#mobile_menu_list .menu-item-172 .dropdown-toggle').attr('aria-expanded',true).toggleClass('show');
			$('#mobile_menu_list .menu-item-172 .dropdown-menu').toggleClass('show');
		}
	});


	$('#our_treatments_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		infinite: true,
		arrows: true,
		prevArrow: $('.t_prev'),
		nextArrow: $('.t_next'),
		responsive: [
			{
				breakpoint: 769,
				settings: {					
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
					autoplaySpeed: 5000,
				},

			}
		]
	});

	$('#accreditations_carousel').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    var slidesToShow = slick.slickGetOption('slidesToShow');
	    var curPage = parseInt((i-1)/slidesToShow) + 1;
	    var lastPage =  parseInt((slick.slideCount-1)/slidesToShow) + 1;
	    $('.acc_current').text(curPage);
	    $.fn.matchHeight._groups;
	});

	$('#accreditations_carousel').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		autoplay: false,
		infinite: true,
		arrows: true,
		prevArrow: $('.acc_prev'),
		nextArrow: $('.acc_next'),
		responsive: [
			{
				breakpoint: 769,
				settings: {					
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
					autoplaySpeed: 5000,
				},

			}
		]
	});

	$('.faq_more').click(function(event) {
		event.preventDefault();
		$('#faq_accordion .card.hide_xs').toggleClass('show');
		$(this).text($(this).text() == 'Load more' ? 'Show less' : 'Load more');
	});

	$('.hospital_more').click(function(event) {
		$(this).text($(this).text() == 'Read more' ? 'Read less' : 'Read more');
	});

	var funding_height = $('#funding img').outerHeight(true);
	var funding_height_half = funding_height / 2;
	$('#funding_bg').css('height',funding_height);
	$('#funding_bgx').css('height',funding_height_half);

	$( window ).resize(function() {
		var funding_height_resize = $('#funding img').outerHeight(true);
		var funding_height_half_resize = funding_height_resize / 2;
	    $('#funding_bg').css('height',funding_height_resize);
	    $('#funding_bgx').css('height',funding_height_half_resize);
	});

	$('#funding_carousel').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		infinite: true,
		arrows: false,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					arrows: true,
					prevArrow: $('.fc_prev'),
					nextArrow: $('.fc_next'),
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
					autoplaySpeed: 5000,
				},

			}
		]
	});

	$('#team_carousel').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		autoplay: false,
		infinite: true,
		arrows: true,
		prevArrow: $('.team_prev'),
		nextArrow: $('.team_next'),
		responsive: [
			{
				breakpoint: 769,
				settings: {	
					autoplay: true,
					autoplaySpeed: 5000,			
					slidesToShow: 1,
					slidesToScroll: 1,
				},

			}
		]
	});

	$('#team_individual_carousel').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: false,
		infinite: true,
		arrows: true,
		prevArrow: $('.ti_prev'),
		nextArrow: $('.ti_next'),
		responsive: [
			{
				breakpoint: 769,
				settings: {	
					autoplay: true,
					autoplaySpeed: 5000,				
					slidesToShow: 1,
					slidesToScroll: 1,
				},

			}
		]
	});

	$('#downloads_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		infinite: true,
		arrows: true,
		prevArrow: $('.download_prev'),
		nextArrow: $('.download_next'),
	});

	$('#filter select[name="cat"').select2({
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
		placeholder: 'Category',
	});

	$('#filter select[name="archive-dropdown"').select2({
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
		placeholder: 'Archive',
	});


	if ($('.blog').length > 0) {
		if ($(window).width() > 992) {
			var navHeight = $('#main-nav').outerHeight(true);
			$('#featured').css('padding-top',navHeight);
		}
	};

	if ($('.single-post').length > 0) {
		if ($(window).width() > 992) {
			var navHeight = $('#main-nav').outerHeight(true);
			$('#content').css('padding-top',navHeight);
		}
		$('#related_carousel').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: false,
			infinite: true,
			arrows: true,
			prevArrow: $('.news_prev'),
			nextArrow: $('.news_next'),
			responsive: [
				{
					breakpoint: 769,
					settings: {			
						autoplay: true,
						autoplaySpeed: 5000,		
						slidesToShow: 1,
						slidesToScroll: 1,
					},

				}
			]
		});
	};

});
